var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"size":"xl","button-size":"md","hide-footer":"","title":_vm.prefix +  ' > ' +  _vm.title},on:{"hidden":_vm.cancelar},model:{value:(_vm.modalAberto),callback:function ($$v) {_vm.modalAberto=$$v},expression:"modalAberto"}},[_c('ApoliceSeguroIBPList',{attrs:{"prefix":_vm.prefix,"id":_vm.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }